<template>
<div class="solution">
 <div class="content">
      <div class="p1">
        <img src="../assets/img/s-back.png" alt="">
      </div>
      <div class="p2">
        <img src="../assets/img/s-back.png" alt="">
      </div>
      <!-- 实体商业 -->
      <div class="con c_con">
        <div class="con_a lbox1">
        </div>
        <div class="con_b lbox2">
          <p style="font-size: 1.456rem;">社区物业电商</p>
          <p style=" font-size: 1.456rem;">解决方案</p>
        </div>
        <div class="con_c">
          <div style="font-size: 0.832rem; line-height: 1.664rem;">
            <p>提供物业服务产品综合商城，为业主提供更多的物业增值服务，支持社区商业入驻；</p>
            <p>提供商品管理、订单管理、员工管理、提现等服务，后台统一对社区商业进行管理审核；</p>
            <p>提供丰富的营销插件以应对各种营销类商业需求</p>
          </div>
        </div>
        <div class="service">
            <div>详情咨询</div>
            <div><img src="../assets/img/right.png" alt=""></div>
        </div>
      </div>

      <!-- 互动营销 -->
      <div class="slk1 c_con">
        <div class="slk1_l">
          <img src="../assets/img/h2.png" alt="">
        </div>
        <div class="slk1_r">
          <div class="slk1_box1"></div>
          <div style="font-size: 1.456rem; font-weight: bold;margin: 0.52rem 0 2.184rem 0;">购物中心解决方案</div>
          <div style="font-size: 0.832rem; line-height: 1.664rem;white-space: nowrap;">
            <p>为商业项目提供专属企鹅智慧⼩程序，上线小程序直播模块，结合商场线上购物平台，</p>
            <p>形成直播带货交易闭环；结合商业运营会员管理的关键，加强对用户的粘度，</p>
            <p>通过融通线上线下直连用户，行程转化与交易的短链闭环。沉淀商业的自有用户和数字化资产，</p>
            <p>实现对消费者的高效管理。同时，提供全面的客户群体画像，分析用户的消费意向、 </p>
            <p>兴趣爱好等标签，为后期运营提供准确的数据支持。</p>
          </div>
          <div class="service" style="width: 26%; float: right;">
              <div>详情咨询</div>
              <div><img src="../assets/img/right.png" alt=""></div>
          </div>
        </div>
      </div>
      <!-- 直击商业 -->
      <div class="slk2 c_con">
          <div class="slk2_l">
            <div class="slk2_box1"></div>
            <div style="font-size: 1.456rem; font-weight: bold;margin: 0.52rem 0 2.184rem 0;">购物中心解决方案</div>
            <div style="font-size: 0.832rem; line-height: 1.664rem;white-space: nowrap;">
              <p>为商业项目提供专属企鹅智慧⼩程序，上线小程序直播模块，结合商场线上购物平台，</p>
              <p>形成直播带货交易闭环；结合商业运营会员管理的关键，加强对用户的粘度，</p>
              <p>通过融通线上线下直连用户，行程转化与交易的短链闭环。沉淀商业的自有用户和数字化资产，</p>
              <p>实现对消费者的高效管理。同时，提供全面的客户群体画像，分析用户的消费意向、 </p>
              <p>兴趣爱好等标签，为后期运营提供准确的数据支持。</p>
            </div>
            <div class="service" style="width: 26%;">
                <div>详情咨询</div>
                <div><img src="../assets/img/right.png" alt=""></div>
            </div>
          </div>
          <div class="slk2_r">
            <img src="../assets/img/h3.png" alt="">
          </div>
      </div>
       <!-- 底部 -->
      <div class="food">
        <div class="food_t" style="20px">
          <div class="food_l">
            <p>ADRESS：</p>
            <p>陕西省西安市雁塔区雁塔南路885号西安金辉环球广场</p>
          </div>
          <div class="food_r">
            <div>联系我们：</div>
            <div><img style="width: 100%;" src="../assets/img/erm.jpg" alt=""></div>
          </div>
        </div>
        <div class="food_b" style="font-size: 0.832rem;">Copyright © 2018 企鹅互动网络版权所有[官方网站]   <a style="color:#FFF;" href="https://beian.miit.gov.cn/" target="_blank">陕ICP备16018502号-2</a></div>
      </div>
    </div>

</div>
</template>
<script>

export default {
  name: "solution",
  components:{
  }
}
</script>
<style scoped>
  html{
    font-size:1vw;
  }
  .page{
      width: 100%;
      /* min-width: 1700px; */
      position: relative;
    }
  .content{
    width: 100%;
    position: absolute;
  }
    /* 实体商业 */
  .c_con{
    width: 58%;
    margin: 0 21%;
  }
  .con{
    position: absolute;
    top: -9.88rem;
    left: 0;
    right: 0;
  }
  .con_a{
    height: 2px;
    background-color: #FFCE00;
  }
  .lbox1{
    width: 3%;
  }
  .lbox2{
     width: 17.5%;
  }
  .con_b{
    font-weight: bolder;
    white-space:nowrap;
    line-height: 2.392rem;
    margin-top: 0.78rem;
  }
  .con_c{
    margin-top: 1.352rem;
    position: relative;
  }
  .service{
    width: 18%;
        background: #F5BF1E;
        color: #000000;
        font-size: 1.456rem;
        font-weight: bold;
        text-align: center;
        padding: 0.78rem 0.26rem;
        margin-top: 2.08rem;
        border-radius: 10px;
  }
  .service>div{
    display: inline-block;
    vertical-align: middle;
  }
  /* 方案2 */
  .slk1{
    margin-top: 11.024rem;
  }
  .slk1>div{
    display: inline-block;
  }
  .slk1_l{
    width: 27.5%;
    height: 18.356rem;
  }
  .slk1_l>img{
    width: 100%;
    height: 100%;
  }
  .slk1_r{
    width: 72.5%;
    float: right;
    text-align: right;
  }
  .slk1_box1{
    width: 4.5%;;
    height: 2px;
    background: #FFCE00;
    float: right;
  }

  .slk2{
    margin-top: 2.704rem;
  }
  .slk2>div{
    display: inline-block;
  }
  .slk2_r{
    width: 27.5%;
    height: 18.356rem;
    float: right;
  }
  .slk2_r>img{
    width: 100%;
    height: 100%;
  }
  .slk2_l{
    width: 72.5%;
    text-align: left;
  }
  .slk2_box1{
    width: 4.5%;;
    height: 2px;
    background: #FFCE00;
  }




  .p1{
      width: 34%;
      height: 10.92rem;
      position: absolute;
      top: 6.24rem;
      left: -12.012rem;
  }
  .p1>img{
    width: 100%;
  }
  .p2{
      width: 34%;
      height: 17.16rem;
      position: absolute;
      top: 26.26rem;
      right: 0;
      overflow: hidden;
  }
  .p2>img{
    width: 100%;
    position: absolute;
    right:-15.288rem ;
  }

  /* 底部 */
 .food{
   width: 100%;
   height: 11.596rem;
   background: #333333;
   color: #FFFFFF;
   margin-top: 2.04rem;
 }
 .food_t{
   width: 58%;
   margin: 0 21%;
   padding-top: 2.132rem;
 }
 .food_t>div{
   display: inline-block;
   vertical-align: middle;
 }
 .food_b{
   text-align: center;
 }
 .food_l{
       margin-top: 1.04rem;
       line-height: 1.56rem;
 }
 .food_r{
   float: right;
 }
 .food_r>div{
   display: inline-block;
   vertical-align: middle;
 }
 .food_r>div:nth-child(2){
   width: 5.72rem;
   height: 5.72rem;
   background: #FFFFFF;
   border-radius: 10px;
 }
 .food_b{
   margin-top: 2.132rem;
   font-size: 0.624rem;
 }
</style>



// WEBPACK FOOTER //
// src/components/solution.vue